import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody} from 'reactstrap';
import UploadFile from '../includes/UploadFile';
import * as galleryActions from "../../actions/gallery";
import {withRouter} from "react-router";
import connect from "react-redux/es/connect/connect";
import ReactAudioPlayer from 'react-audio-player';
import {Player} from "video-react";
import * as uploadActions from "../../actions/upload";
import AuthService from '../../lib/AuthService';


class NewItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            vname_class : '',
            vtags_class : '',
            title: '',
            tags: '',
            modal: false,
            redirect: false,
            builderState : false,
            builderUrl : '',
            image_path: null,
            file_name : '',
            itemName : '',
            imageError : "",
            titleError : "",
            itemError : ''

        };
        this.Auth = new AuthService();
        this.toggle = this.toggle.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.showBuilder = this.showBuilder.bind(this);
        this.hideBuilder = this.hideBuilder.bind(this)
        this.getFileType = this.getFileType.bind(this);
        this.resetState  = this.resetState.bind(this);
        this.removePreview = this.removePreview.bind(this);

    }

    renderTitle() {
        let titleText = "Add ";
        switch(this.props.item_type) {
            case 'VIGNETS':
                return titleText += 'Vignets';
            case 'MY_UPLOADS':
                return titleText += 'Gallery';
            case 'AUDIO':
                return titleText += 'Audio';
            case 'VIDEO':
                return titleText += 'Video';
            case 'PLAYLIST':
                return titleText += 'Playlist';
            default:
                return titleText += 'Vignets';
        }
    }

    getItemName() {
        switch(this.props.item_type) {
            case 'VIGNETS':
                return 'Image';
            case 'MY_UPLOADS':
                return 'Image';
            case 'AUDIO':
                return 'Audio';
            case 'VIDEO':
                return 'Video';
            default:
                return 'Vignet';
        }
    }

    getFileType() {
        switch(this.props.item_type) {
            case 'VIGNETS':
                return 'image';
            case 'MY_UPLOADS':
                return 'image';
            case 'AUDIO':
                return 'audio';
            case 'VIDEO':
                return 'video';
            default:
                return 'Vignet';
        }
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
        this.resetState();
    }
    resetState(){
        this.setState({
            image_path : null,
            title: '',
            tags: '',
            file_name : '',
            item_type : '',
            imageError : "",
            titleError : "",
            itemError : ''
        });
        this.props.uploadErrors({'error' : '', fileType : ''});
    }
    getUploadedFile(fileName) {
        var image_path = null;

        if (this.props.item_type === 'AUDIO') {
            image_path= 'assets/images/no-audio.jpg';
        }
        else if (this.props.item_type === 'VIDEO') {
            image_path= 'assets/images/no-video.jpg';
        }
        else  if( this.props.item_type === 'MY_UPLOADS') {
            image_path =  fileName;

        }

        this.setState({
            image_path: image_path,
            file_name : fileName
        });
        document.getElementsByClassName('modal-adduser-img')[0].classList.remove('is-invalid');

    }

    showBuilder(e) {
        e.preventDefault();
        this.setState({
            builderState : true
        });
        this.handleSubmit(e, this.state.builderState);
    }

    hideBuilder(e) {
        e.preventDefault();
        this.setState({
            builderState : false
        });
        this.handleSubmit(e, this.state.builderState);
    }

    handleInputChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });

        if(event.target.value !== '') {
            event.target.classList.remove('is-invalid');
        }
        if(this.state.title !== ''){
            this.setState({
                titleError: ''
            });
        }
    }

    handleSubmit(e) {
        //alert("111");
        e.preventDefault();
        let formInvalid = 0;

        if( this.state.title === '') {
            formInvalid++;
            document.getElementsByName('title')[0].classList.add('is-invalid');
            this.setState({
                titleError: 'Title is required'
            });
        }

        if( this.state.file_name === '') {
            formInvalid++;
            this.setState({imageError : "Please upload a file"});
            document.getElementsByClassName('modal-adduser-img')[0].classList.add('is-invalid');
            this.setState({
                itemError: this.getItemName() + ' is required'
            });
        }

        if( formInvalid === 0) {

            var galData = { userid : this.Auth.getProfile().user_id ,title :this.state.title, imgpth : this.state.file_name, tags: this.state.tags, imgtyp : this.props.item_type};

            let created = this.props.createGallery(galData);
            this.toggle();

        }
    }
    removePreview(){
        this.setState({
            file_name : ''
        });
    }

    render() {
        let defImgSrc = require("../../assets/images/no-image.jpg");
        return (
            <div>
                {this.props.viewModestatus.viewMode === "grid" &&
                        <div className="glery-main new-gal" data-toggle="modal" data-target="#newModal"
                             onClick={this.toggle}>
                            <div className="glery-image">
                                <button className="icon-lib add-button float-add"></button>
                            </div>
                            <div className="ind-tb glery-text audio-white ">
                                <p>{this.renderTitle()}</p>
                                <button className="add-image glery-add-icon ">
                                    <input type="" name="" className="add-file"/>
                                </button>
                            </div>
                        </div>
                }
                {this.props.viewModestatus.viewMode === "list" &&
                <div className="float-button-block" data-toggle="tooltip" data-placement="top" title=""
                     data-original-title="New User">
                    <button className="float-button icon-lib float-add" data-task="new-user"
                            data-target="#newuser" onClick={this.toggle}></button>
                </div>
                }
                <Modal isOpen={this.state.modal} toggle={this.toggle} centered={true} className={(this.state.file_name !== '' && this.props.item_type === 'VIDEO') ? "vig-mod modal-lg vig-modal user-md create-new-pop vd-mod" : "vig-mod modal-lg vig-modal user-md create-new-pop" }>
                    <ModalBody>
                        <div className="modal-content-wrapper">
                            <div className="modal-header">
                                <form id="company">
                                    <button type="button" className="modal-btn-close" data-dismiss="modal" aria-label="Close" onClick={this.toggle} >✕</button>
                                    <h4 className="modal-title">Add New {this.getItemName()}</h4>
                                </form>
                            </div>
                            <div className="modal-adduser-content">
                                <div className="modal-adduser-content-left">
                                    <div className="modal-adduser-detail">
                                        <p>TITLE</p>
                                        <div className="input-select">
                                            <input type="text" name="title" id="title" placeholder="Title" onChange={this.handleInputChange} valid={false} />
                                            <p className="error-message">{this.state.titleError}</p>
                                        </div>
                                    </div>
                                    <div className="modal-adduser-detail">
                                        <p>TAGS</p>
                                        <div className="input-select desc-area">
                                            <textarea type="textarea" name="tags" id="tags" className="form-text" placeholder="Tags" onChange={this.handleInputChange} valid={false}/>
                                        </div>
                                    </div>
                                </div>

                                <div className="modal-adduser-content-right">
                                    <div className="modal-adduser-detail">
                                        {(this.state.file_name === '' || this.props.item_type !== 'VIDEO') &&
                                        <div className="modal-adduser-img">
                                            <div className="image-up">
                                                {this.state.image_path &&
                                                <img src={this.state.image_path} crossOrigin="anonymous"
                                                     className="text-center" alt="vignet"/>
                                                }
                                                {this.state.image_path === null && this.props.item_type === 'MY_UPLOADS' &&
                                                <img src="assets/images/placeholder.png" alt="default"/>
                                                }
                                                {this.state.image_path === null && this.props.item_type === 'AUDIO' &&
                                                <img src="assets/images/no-audio.jpg" alt="default"/>
                                                }
                                                {this.state.image_path === null && this.props.item_type === 'VIDEO' &&
                                                <img src="assets/images/no-video.jpg" alt="default"/>
                                                }

                                                <UploadFile getUploadedFile={this.getUploadedFile.bind(this)} type="add"
                                                            item_type={this.props.item_type}
                                                            fileType={this.getFileType()} unique_id=""/>

                                                {console.log(this.state.image_path)}
                                                {console.log(this.props.uploadData.loader)}

                                                {(this.state.image_path === null || this.props.uploadData.loader === true) &&
                                                <div id="progress-bar-wrapper"></div>
                                                }


                                            </div>
                                        </div>
                                        }
                                        {this.state.file_name === '' &&
                                            <p className="error-message">{this.state.itemError}</p>
                                        }
                                        {this.state.file_name !== '' && this.props.item_type === 'AUDIO' &&
                                        <ReactAudioPlayer id="audio_new" className="audioPlayer"
                                                          src={this.state.file_name}
                                                          controls
                                        />
                                        }
                                        {this.state.file_name !== '' && this.props.item_type === 'VIDEO' &&
                                        <div>
                                        <Player
                                            playsInline
                                            poster= {defImgSrc}
                                            src= {this.state.file_name}
                                            width="95%"
                                            height={200}
                                            fluid = {false}
                                        />
                                            <a href="javascript:void(0);" onClick={this.removePreview} ><p className="error-message" >Remove the video</p></a>
                                        </div>
                                        }
                                        {this.props.uploadData.errors === true &&
                                        <p className="error-message">{this.props.uploadData.errorMessage}</p>
                                        }
                                    </div>
                                </div>
                                <div className="modal-adduser-content-btn">
                                    <div className="modal-btn btn-cancel">
                                        <a href="javascript:void(0);" className="" onClick={this.toggle}>CANCEL</a>
                                    </div>
                                    <div  className="modal-btn btn-create">
                                        <a href="javascript:void(0);" className="" onClick = {(e) => this.handleSubmit(e)}>SAVE</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>


            </div>
        );
    }
}

NewItem.propTypes = {
    completed: PropTypes.number,
    item_type : PropTypes.string

}
function mapStateToProps(state) {
    return {
        uploadData : state.upload.uploadData,
        viewModestatus  :state.gallery.galleryUpdate,
    };
}
export default  withRouter(connect(mapStateToProps, {
    createGallery : galleryActions.createGallery,
    uploadErrors: uploadActions.uploadErrors,
})(NewItem));



// WEBPACK FOOTER //
// ./src/components/common/NewItem.js